import gateway from "@/lib/request/gateway";
export default class UploadImage {
  static async uploadImg(file: File) {
    // const isJPG =
    //   file.type === "image/jpeg" ||
    //   file.type === "image/jpg" ||
    //   file.type === "image/png";
    // 上传图片到oss
    const postRes = await gateway.anonymousGetPostPolicy(file.name);
    if (postRes) {
      const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
      await gateway.upload(postRes, file);
      return tempUrl;
    }
  }
}
